// extracted by mini-css-extract-plugin
export default {"TableActions":"Paginator_TableActions__9S5iJ","PageSizeSelect":"Paginator_PageSizeSelect__03t9j"};